var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRuler3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 13C21.4031 13 22 13.4477 22 14C22 14.5128 21.4853 14.9355 20.8222 14.9933L20.6667 15H3.13673C2.30339 15 2.00001 14.5 2.00001 14C2.00001 13.4872 2.51473 13.0645 3.17785 13.0067L3.33334 13H20.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 8C21.4031 8 22 8.44772 22 9C22 9.51284 21.4853 9.93551 20.8222 9.99327L20.6667 10H3.33334C2.59696 10 2.00001 9.55228 2.00001 9C2.00001 8.48716 2.51473 8.06449 3.17785 8.00673L3.33334 8H20.6667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8C3.51284 8 3.93551 8.33779 3.99327 8.77296L4 8.875V14C4 14.4832 3.55228 14.875 3 14.875C2.48716 14.875 2.06449 14.5372 2.00673 14.102L2.00001 14L2 8.875C2 8.39175 2.44772 8 3 8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8C13.5128 8 13.9355 8.33779 13.9933 8.77296L14 8.875V14C14 14.4832 13.5523 14.875 13 14.875C12.4872 14.875 12.0645 14.5372 12.0067 14.102L12 14V8.875C12 8.39175 12.4477 8 13 8Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17.5128 8 17.9355 8.33779 17.9933 8.77296L18 8.875V14C18 14.4832 17.5523 14.875 17 14.875C16.4872 14.875 16.0645 14.5372 16.0067 14.102L16 14V8.875C16 8.39175 16.4477 8 17 8Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8C21.5128 8 21.9355 8.33779 21.9933 8.77296L22 8.875L22 14C22 14.4832 21.5523 14.875 21 14.875C20.4872 14.875 20.0645 14.5372 20.0067 14.102L20 14V8.875C20 8.39175 20.4477 8 21 8Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRuler3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconRuler3.eb30ef47899ab14fd750594e7df7f8fe.svg";